const language = {
    'pt':
    {
        add_new: 'Adicionar novo',
        cancel: 'Cancelar', back: 'Voltar',
        component: 'Tipos de energia',
        component_new: 'Novo tipo de energia',
        component_edit: 'Editar tipo de energia',
        component_list: 'Lista de tipos de energia',
        close: 'Fechar',
        color: 'Cor',
        color_placeholder: 'Introduza a cor',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        edit: 'Editar',
        edit_title: 'Editar Registo',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao atualizar registo!',
        edit_success: 'Registo atualizado com sucesso!',
        field_activo: 'Ativo?',
        field_visivel: 'Visível?',
        field_avaiable: 'Disponível?',
        field_category: 'Categoria',
        field_category_placeholder: 'Introduza a categoria',
        field_observation: 'Observação',
        field_observation_placeholder: 'Introduza uma observação',
        field_abreviation: 'Abreviatura',
        field_abreviation_placeholder: 'Introduza a abreviação',
        field_adultos: 'Adultos',
        field_adultos_placeholder: 'Introduza o número de adultos',
        field_criancas: 'Crianças',
        field_criancas_placeholder: 'Introduza o número de crianças',
        field_description: 'Descrição',
        field_description_placeholder: 'Introduza a descrição',
        field_forfait: 'Forfait',
        field_forfait_price: 'Preço do Forfait',
        field_forfait_price_placeholder: 'Introduza o preço do Forfait',
        field_forfait_taxe: 'IVA do Forfait',
        field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
        field_equipamento: 'Equipamento',
        field_equipamento_price: 'Preço do Equipamento',
        field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
        field_equipamento_taxe: 'IVA do Equipamento',
        field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
        field_final_price: 'Preço Final',
        field_final_price_palceholder: 'Introduza o Preço Final',
        field_price: 'Preço',
        field_price_since: 'Preço desde',
        field_name: 'Nome',
        field_name_placeholder: 'Introduza o nome',
        field_canhoes: 'Canhões de neve',
        field_status: 'Estado',
        field_comprimento: 'Comprimento',
        field_comprimento_placeholder: 'Inserir comprimento',
        field_dificuldade: 'Dificuldade',
        field_dificuldade_placeholder: 'Inserir dificuldade',
        field_desnivel: 'Desnível (m)',
        field_desnivel_placeholder: 'Inserir desnível (m)',
        field_type: 'Tipo',
        field_duracao: 'Duração',
        field_person: 'Afetação de tecnicos',
        field_appointment: 'Afetação de recursos',
        field_tag: 'Tag',
        field_tag_placeholder: 'Inserir a tag',
        field_link: 'Link',
        field_link_placeholder: 'Inserir o link',
        field_unidade: 'Unidade',
        field_unidade_placeholder: 'Inserir a unidade',
        field_subtitle: 'Subtítulo',
        filter_placeholder: 'Procurar',
        id: 'ID',
        image: 'Imagem',
        images: 'Imagens',
        image_choose: 'Escolher imagem',
        insert_title: 'Novo Registo',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        principal: 'Principal',
        remove: 'Remover',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_title: 'Título',
        table_subtitle: 'Subtítulo',
        table_parent: 'Parent',
        table_date: 'Data',
        table_state: 'Estado',
        table_actions: 'Acções',
        table_empty: 'sem resultados',
        save: 'Salvar',
        upload_image_error: 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n',
        youtube_choose: 'Youtube',
        upload_file_error: 'O ficheiro tem mais de 10MB.',

        field_choose: 'Selecione uma opção',
        unit_A: 'Ampere (A)',
        unit_cm: 'Centímetro (cm)',
        unit_cx: 'Caixa (cx)',
        unit_gal: 'Galão (gal)',
        unit_g: 'Grama (g)',
        unit_kg: 'Quilograma (kg)',
        unit_kWh: 'Quilowatt-hora (kWh)',
        unit_kWp: 'Kilowatt-pico (kWp)',
        unit_L: 'Litro (L)',
        unit_m: 'Metro (m)',
        unit_m2: 'Metro quadrado (m²)',
        unit_m3: 'Metro cúbico (m³)',
        unit_mg: 'Miligrama (mg)',
        unit_mm: 'Milímetro (mm)',
        unit_mL: 'Mililitro (mL)',
        unit_par: 'Par (par)',
        unit_pc: 'Peça (pc)',
        unit_pct: 'Pacote (pct)',
        unit_t: 'Tonelada (t)',
        unit_un: 'Unidade (un)',
        unit_V: 'Volt (V)',
        unit_W: 'Watt (W)',

        field_taxa_iva: 'Taxa IVA',
        taxa_normal_continente: 'Taxa Normal (Continente) - 23%',
        taxa_normal_madeira: 'Taxa Normal (Madeira) - 22%',
        taxa_normal_acores: 'Taxa Normal (Açores) - 18%',
        taxa_intermedia_continente: 'Taxa Intermédia (Continente) - 13%',
        taxa_intermedia_madeira: 'Taxa Intermédia (Madeira) - 12%',
        taxa_intermedia_acores: 'Taxa Intermédia (Açores) - 9%',
        taxa_reduzida_continente: 'Taxa Reduzida (Continente) - 6%',
        taxa_reduzida_madeira: 'Taxa Reduzida (Madeira) - 5%',
        taxa_reduzida_acores: 'Taxa Reduzida (Açores) - 4%',       

    },
    'en':
    {
        add_new: 'Add new',
        calendar: 'Calendar',
        cancel: 'Cancel',
        component: 'Tipos de energia',
        component_new: 'Novo tipo de energia',
        component_edit: 'Editar tipo de energia',
        component_list: 'Lista de tipos de energia',
        close: 'Close',
        color: 'Color',
        color_placeholder: 'Insert the color',
        delete: 'Delete',
        delete_title: 'Delete Regist',
        delete_text: 'Are you sure you want to continue?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_error: 'Problem deleting the element!',
        delete_success: 'Element deleted successfully!',
        edit: 'Edit',
        edit_title: 'Edit Regist',
        edit_text: 'Are you sure you want to continue?',
        edit_confirm: 'Yes',
        edit_cancel: 'No',
        edit_error: 'Problem updating element!',
        edit_success: 'Successful updated element!',
        field_activo: 'Ativo?',
        field_visivel: 'Visível?',
        field_avaiable: 'Disponível?',
        field_category: 'Categoria',
        field_category_placeholder: 'Introduza a categoria',
        field_observation: 'Observação',
        field_observation_placeholder: 'Introduza uma observação',
        field_abreviation: 'Abreviatura',
        field_abreviation_placeholder: 'Introduza a abreviação',
        field_adultos: 'Adultos',
        field_adultos_placeholder: 'Introduza o número de adultos',
        field_criancas: 'Crianças',
        field_criancas_placeholder: 'Introduza o número de crianças',
        field_description: 'Descrição',
        field_description_placeholder: 'Introduza a descrição',
        field_forfait: 'Forfait',
        field_forfait_price: 'Preço do Forfait',
        field_forfait_price_placeholder: 'Introduza o preço do Forfait',
        field_forfait_taxe: 'IVA do Forfait',
        field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
        field_equipamento: 'Equipamento',
        field_equipamento_price: 'Preço do Equipamento',
        field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
        field_equipamento_taxe: 'IVA do Equipamento',
        field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
        field_final_price: 'Preço Final',
        field_final_price_palceholder: 'Introduza o Preço Final',
        field_price: 'Preço',
        field_price_since: 'Preço desde',
        field_name: 'Nome',
        field_name_placeholder: 'Introduza o nome',
        field_canhoes: 'Canhões de neve',
        field_status: 'Estado',
        field_comprimento: 'Comprimento',
        field_comprimento_placeholder: 'Inserir comprimento',
        field_dificuldade: 'Dificuldade',
        field_dificuldade_placeholder: 'Inserir dificuldade',
        field_desnivel: 'Desnível (m)',
        field_desnivel_placeholder: 'Inserir desnível (m)',
        field_type: 'Tipo',
        field_duracao: 'Duração',
        field_person: 'Afetação de tecnicos',
        field_appointment: 'Afetação de recursos',
        field_tag: 'Tag',
        field_tag_placeholder: 'Inserir a tag',
        field_link: 'Link',
        field_link_placeholder: 'Inserir o link',
        field_unidade: 'Unidade',
        field_unidade_placeholder: 'Inserir a unidade',
        field_subtitle: 'Subtítulo',
        filter_placeholder: 'Procurar',
        id: 'ID',
        image: 'Imagem',
        images: 'Imagens',
        image_choose: 'Escolher imagem',
        insert_title: 'New Regist',
        insert_text: 'Are you sure you want to continue?',
        insert_confirm: 'Yes',
        insert_cancel: 'No',
        insert_error: 'Problem updating element!',
        insert_success: 'Successful updated element!',
        principal: 'Principal',
        remove: 'Remove',
        table_rows_per_page: 'Regist by page:',
        table_separator: 'of',
        table_all: 'All',
        table_title: 'Title',
        table_subtitle: 'Subtitle',
        table_parent: 'Parent',
        table_date: 'Date',
        table_state: 'State',
        table_actions: 'Actions',
        table_empty: 'no results',
        save: 'Save',
        upload_image_error: 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n',
        youtube_choose: 'Youtube',
        upload_file_error: 'O ficheiro tem mais de 10MB.',

        field_choose: 'Select an option',
        unit_A: 'Ampere (A)',
        unit_cm: 'Centimeter (cm)',
        unit_cx: 'Box (cx)',
        unit_gal: 'Gallon (gal)',
        unit_g: 'Gram (g)',
        unit_kg: 'Kilogram (kg)',
        unit_kWh: 'Kilowatt-hour (kWh)',
        unit_kWp: 'Kilowatt-peak (kWp)',
        unit_L: 'Liter (L)',
        unit_m: 'Meter (m)',
        unit_m2: 'Square meter (m²)',
        unit_m3: 'Cubic meter (m³)',
        unit_mg: 'Milligram (mg)',
        unit_mm: 'Millimeter (mm)',
        unit_mL: 'Milliliter (mL)',
        unit_par: 'Pair (par)',
        unit_pc: 'Piece (pc)',
        unit_pct: 'Package (pct)',
        unit_t: 'Ton (t)',
        unit_un: 'Unit (un)',
        unit_V: 'Volt (V)',
        unit_W: 'Watt (W)',

        field_taxa_iva: 'Tax IVA',   
        taxa_normal_continente: 'Normal Rate (Continente) - 23%',
        taxa_normal_madeira: 'Normal Rate (Madeira) - 22%',
        taxa_normal_acores: 'Normal Rate (Açores) - 18%',
        taxa_intermedia_continente: 'Intermediate Rate (Continente) - 13%',
        taxa_intermedia_madeira: 'Intermediate Rate (Madeira) - 12%',
        taxa_intermedia_acores: 'Intermediate Rate (Açores) - 9%',
        taxa_reduzida_continente: 'Reduced Rate (Continente) -  6%',
        taxa_reduzida_madeira: 'Reduced Rate (Madeira) - 5%',
        taxa_reduzida_acores: 'Reduced Rate (Açores) - 4%',           

    }
}

module.exports = {
    language
};